<template>
  <div class="modal" :class="{'bottom-sheet': bottom, 'modal-fixed-footer': fixedFooter}" ref="modal" :id="target">
    <div v-if="opened">
      <div class="modal-content">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <slot name="footer">
          <button @click="close" class="modal-action modal-close waves-effect waves-green btn-flat">Fechar</button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      'target': {
        type: String,
        required: true
      },
      'bottom': {
        type: Boolean
      },
      'fixed-footer': {
        type: Boolean,
        default: false
      },
      'open': {
        type: Boolean,
        default: false
      }
    },
    watch: {
      open: function (newVal, oldVal) {
        console.log('ABRE', newVal, oldVal);
        if (newVal == true) {
          this.show();
        }
      }
    },
    mounted: function () {

      let that = this;
      var options = {
        onOpenEnd: function (modal, trigger) {
          //that.opened = true;
          that.$emit('opened');
        },
        onCloseStart: function () {
          //that.opened = false;
          that.$emit('close');
        }
      };
      console.log('modalinit');

      M.Modal.init(this.$refs.modal, options);
      let instance = M.Modal.getInstance(this.$refs.modal);
      if (!!this.open) {
        this.show();
      }
      // console.log('zzzzzzzzzzzzzzz  zzzzzzzzzz', instances)

      bus.$on('close-modal', () => {
        console.log('close-modal!!');
        //$(this.$refs.modal).modal('close');
        //var instance = M.Modal.getInstance(this.$refs.modal);
        console.log(this.$refs);

        let instance = M.Modal.getInstance(this.$refs.modal);
        instance.close();
      });
    },
    data() {
      return {
        opened: true
      }
    },
    methods: {
      show() {
        console.log('Show')
        var instance = M.Modal.getInstance(this.$refs.modal);
        instance.open();
      },
      close: function () {
        //$(this.$refs.modal).modal('close');
        console.log('close');
        var instance = M.Modal.getInstance(this.$refs.modal);
        instance.close();
      }
    },
    destroyed: function () {

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/utils/Modal.vue